import React from 'react';
import TableContainerRow from './TableContainerRow/TableContainerRow';
import DaysTopRow from './DaysTopRow/DaysTopRow';
import Proptypes from 'prop-types';

export class TableContainer extends React.Component {
  static propTypes = {
    tableData: Proptypes.array,
    isXsScreen: Proptypes.any
  };

  constructor(props) {
    super(props);
    this.state = { isXsScreen: false };
  }

  componentDidMount = () => {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateWindowDimensions);
  };

  updateWindowDimensions = () => {
    if (window.innerWidth <= 425) {
      this.setState({ isXsScreen: true });
    } else {
      this.setState({ isXsScreen: false });
    }
  };

  renderTableContainerRows() {
    let { isXsScreen } = this.state;
    let { tableData } = this.props;
    let rows = [];
    tableData.map((data, index) => {
      return rows.push(<TableContainerRow isXsScreen={isXsScreen} key={index} rowData={data} weekNumber={index + 1} />);
    });
    return rows;
  }

  render() {
    let { isXsScreen } = this.state;
    return (
      <div className="basic-analytics-table-container">
        <div>
          <DaysTopRow isXsScreen={isXsScreen} />
          {this.renderTableContainerRows()}
        </div>
      </div>
    );
  }
}

export default TableContainer;
